import { useContext } from "react";

import { JourneyContext } from "@context/journey.context";

export const useJourney = () => {
  const {
    currentMap,
    isJourneyLoading,
    journeyMapErrored,
    journeyMapView,
    nextMapUnlocked,
    requestMapChange,
    requestStepChange,
    setJourneyMapView,
    unlockedSteps,
  } = useContext(JourneyContext);

  return {
    currentMap,
    isJourneyLoading,
    journeyMapErrored,
    journeyMapView,
    nextMapUnlocked,
    requestMapChange,
    requestStepChange,
    setJourneyMapView,
    unlockedSteps,
  };
};
